import { Table } from 'components/core-ui/Table'
import { useMemo, useState } from 'react'
import { getColumns } from './helpers'
import { makeCoreGetRequest } from 'utils/api'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { toTableRowItems } from './serializers'
import { useNotification } from 'hooks'
import { formatErrorMessage } from 'utils/formatting'
import { useNavigate } from 'react-router-dom'
import { ViewActionIcon } from 'icons'

const AssignmentsTable = props => {
  const { legalEntityId, storeId } = props

  // TODO define interfaces for table items
  const [tableItems, setTableItems] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [shouldResetPage, setShouldResetPage] = useState<boolean>(false)

  const { showNotification } = useNotification()

  const navigate = useNavigate()

  const columns = useMemo(() => getColumns(), [])

  const fetchData = async ({ page, rowsPerPage, order, orderBy }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: '/iam/external-partners/assignments',
          tableFilters: [
            legalEntityId
              ? { name: 'legalEntity.id', value: legalEntityId }
              : storeId
              ? { name: 'stores.id', value: storeId }
              : null
          ],
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list || []))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `There was an error fetching assignments. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  return (
    <div>
      <Table
        hideCheckbox
        orderBy="createdDate"
        order="desc"
        title="Assignments"
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        shouldResetPage={shouldResetPage}
        setShouldResetPage={setShouldResetPage}
        rowActions={[
          {
            label: 'Details',
            labelColor: 'white',
            typographyVariant: 'medium',
            backgroundColor: '#0970E6',
            desktopIcon: <ViewActionIcon />,
            onClick: (_e: React.MouseEvent<HTMLElement>, rowId: number) =>
              navigate(`/iam/externalPartners/assignments/${rowId}`)
          }
        ]}
        rowActionsWidth="80px"
        desktopRowActionsWidth="50px"
      />
    </div>
  )
}

export default AssignmentsTable
